var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconQrSec(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 28.5C21.1716 28.5 20.5 29.1716 20.5 30C20.5 30.8284 21.1716 31.5 22 31.5V28.5ZM31.5 20C31.5 19.1716 30.8284 18.5 30 18.5C29.1716 18.5 28.5 19.1716 28.5 20H31.5ZM10 31.5C10.8284 31.5 11.5 30.8284 11.5 30C11.5 29.1716 10.8284 28.5 10 28.5V31.5ZM3.5 20C3.5 19.1716 2.82843 18.5 2 18.5C1.17157 18.5 0.5 19.1716 0.5 20H3.5ZM10 3.5C10.8284 3.5 11.5 2.82843 11.5 2C11.5 1.17157 10.8284 0.5 10 0.5V3.5ZM0.5 12C0.5 12.8284 1.17157 13.5 2 13.5C2.82843 13.5 3.5 12.8284 3.5 12H0.5ZM22 0.5C21.1716 0.5 20.5 1.17157 20.5 2C20.5 2.82843 21.1716 3.5 22 3.5L22 0.5ZM28.5 12C28.5 12.8284 29.1716 13.5 30 13.5C30.8284 13.5 31.5 12.8284 31.5 12L28.5 12ZM22 31.5C27.2467 31.5 31.5 27.2467 31.5 22H28.5C28.5 25.5899 25.5899 28.5 22 28.5V31.5ZM31.5 22V20H28.5V22H31.5ZM10 28.5C6.41015 28.5 3.5 25.5899 3.5 22H0.5C0.5 27.2467 4.75329 31.5 10 31.5V28.5ZM3.5 22L3.5 20H0.5L0.5 22H3.5ZM10 0.5C4.75329 0.5 0.5 4.75329 0.5 10H3.5C3.5 6.41015 6.41015 3.5 10 3.5V0.5ZM0.5 10L0.5 12H3.5L3.5 10H0.5ZM22 3.5C25.5899 3.5 28.5 6.41015 28.5 10L31.5 10C31.5 4.75329 27.2467 0.5 22 0.5L22 3.5ZM28.5 10V12L31.5 12V10L28.5 10Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 16H6",
    stroke: "#F2F2F2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQrSec);
export default __webpack_public_path__ + "static/media/iconQrSec.ca687f8718d58812c18c88f8ac5c16ba.svg";
export { ForwardRef as ReactComponent };